<template>
  <div class="driver-payouts">
    DRIVER PAYOUTS {{ provId }}
    <div class="account-info" v-if="account !== null">
      {{ account.id }}
    </div>
    <div class="external-accounts" v-if="externalAccounts !== null">
      <div class="external-account" v-for="exAcct in externalAccounts">
        {{ exAcct.accountType }}{{ exAcct.lastFour }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'driver-payouts',
  props: ['provId'],
  data () {
    return {
      account: null,
      externalAccounts: null
    }
  },
  methods: {
    init () {
      let self = this
      self.$sdk.get('/provider/' + self.provId + '/account', {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          self.account = null
          self.externalAccount = null
          return
        }
        self.account = r.account
        self.externalAccounts = r.externalAccounts
      })
    }
  },
  watch: {
    provId: function (value) { this.init() }
  },
  mounted () { this.init() }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Provider/DriverPayouts.vue